import { Steps } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { defaultClientStepSelector } from "store/user/(default)/client/default_client.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycStepper = () => {
  // -------------------------- VAR -----------------------------
  const items = [
    // {
    //   title: "Thông tin liên hệ",
    // },
    // {
    //   title: "Thông tin Cơ bản",
    // },
    // {
    //   title: "Thông tin Tài chính",
    // },
    // {
    //   title: "Xác minh Danh tính (KYB)",
    // },
    {
      title: "Tài liệu Pháp lý Liên Quan",
    },
  ];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------

  const current = useSelector(defaultClientStepSelector);

  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <Steps current={current} items={items} direction="vertical" />;
};
export default KycStepper;
